import QueryManager from "../../../global/utils/QueryManager";
import {getLocalStorageKey} from "../../../settings";
import {OfficersFiltersTypes} from "./Officers.filters.types";

const curLocalStorageKey = getLocalStorageKey("officers_filters");

let officerFiltersSerializableDates = [
    OfficersFiltersTypes.SignedDate,
]

let officerFiltersSerializableJoins = [
    OfficersFiltersTypes.PopState,
    OfficersFiltersTypes.Naics,
    OfficersFiltersTypes.PscCode,
]

class OfficersFiltersManagerClass extends QueryManager {}

const OfficersFiltersManager = new OfficersFiltersManagerClass({
    serializable: {dates: officerFiltersSerializableDates, joins: officerFiltersSerializableJoins},
    localStorageKey: curLocalStorageKey
});

export default OfficersFiltersManager;